import { PupilsConstants } from './pupils.constants'
import { IPupilsState, IPupilsAction } from './pupils.types'

export const initialPupilsState: IPupilsState = {
  pupilSizeL: null,
  pupilRxL: null,
  pupilSizeR: null,
  pupilRxR: null,
  headReactive: '',
}

export function pupilsReducer(state: IPupilsState = initialPupilsState, action: IPupilsAction): IPupilsState {
  switch (action.type) {
    case PupilsConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case PupilsConstants.SET_PUPILSIZEL:
      return { ...state, pupilSizeL: action.pupilSizeL }
    case PupilsConstants.SET_PUPILRXL:
      return { ...state, pupilRxL: action.pupilRxL }
    case PupilsConstants.SET_PUPILSIZER:
      return { ...state, pupilSizeR: action.pupilSizeR }
    case PupilsConstants.SET_PUPILRXR:
      return { ...state, pupilRxR: action.pupilRxR }
    case PupilsConstants.SET_HEADREACTIVE:
      return { ...state, headReactive: action.headReactive }

    case PupilsConstants.SET_PUPILS:
      return { ...state, ...action.pupils }
    case PupilsConstants.RESET_PUPILS_STATE:
      return { ...state, ...initialPupilsState }

    default:
      return state
  }
}
